<template>
  <div>
    <div id="chat_window" class="chat_window">
      <ul class="messages" ref="container" id="container">
        <div v-show="loading" class="text-center text-primary mt-5">
          <b-spinner class="align-middle"></b-spinner>
          <strong class="ml-2">Cargando...</strong>
        </div>
        <li
          v-for="msg in messages"
          :key="msg.id"
          
          class="message appeared text-light-black text-left"
          v-bind:class="{
            left: msg.user.id != id_admin,
            right: msg.user.id == id_admin,
          }"
        >
          <img
            class="avatar"
            v-if="msg.user.profile_picture"
            :src="msg.user.profile_picture"
          />
          <img class="avatar" src="" v-if="!msg.user.profile_picture" />

          <div class="text_wrapper">
            <div class="row">
              <b-col md="9">
                <div class="text" v-if="msg.url_archive">
                  <a target="a_blank" :href="msg.url_archive">
                    <img
                      style="max-width: 300px"
                      class="img-fluid"
                      :src="msg.url_archive"
                      v-if="msg.type_archive == 1"
                    />
                    <br />
                    <v-icon
                      style="color: gray"
                      scale="3"
                      v-if="msg.type_archive == 3"
                      name="file-alt"
                    ></v-icon>
                    <v-icon
                      style="color: gray"
                      scale="3"
                      v-if="msg.type_archive == 2"
                      name="play-circle"
                    ></v-icon>

                    <br />

                    <span style="font-size: 12px" v-if="msg.type_archive == 2"
                      >Escuchar Audio</span
                    >
                    <span style="font-size: 12px" v-if="msg.type_archive == 3"
                      >Ver Documento</span
                    >
                    <span style="font-size: 12px" v-if="msg.type_archive == 1"
                      >Ver Imagen</span
                    ></a
                  >
                </div>
                <div class="text">
                  <span style="font-size: 12px"
                    ><strong>{{ msg.message }}</strong></span
                  >
                </div>
              </b-col>
              <b-col md="3">
                <label
                  v-if="msg.user.id != id_admin"
                  style="font-size: 10px; color: white"
                  >{{ msg.updated_at }}</label
                >
                <label
                  v-if="msg.user.id == id_admin"
                  style="font-size: 10px; color: black"
                  >{{ msg.updated_at }}</label
                >
                <!-- <b-button
                  v-if="msg.user_id == id_admin"
                  @click="deleteMsg(msg.id)"
                  v-b-tooltip.hover
                  title="Eliminar este mensaje"
                  variant="danger"
                  size="sm"
                >
                  <v-icon name="trash" />
                </b-button> -->
              </b-col>
            </div>
          </div>
        </li>
      </ul>

      <div class="bottom_wrapper clearfix">
        <b-row>
          <b-col md="3" sm="4" cols="12">
            <b-button
              style="border-radius: 15px; border: none"
              class="btn-card-color "
              @click="ScrollButton()"
              ><span class="text-font-white" style="font-size: 15px"
                >Ir al final</span
              ></b-button
            >
          </b-col>
          <b-col md="7" sm="6" cols="8">
            <b-form-textarea
              pill
              @keyup.enter="send_msg()"
              v-model="message_post"
              placeholder="Escribir"
            ></b-form-textarea>
          </b-col>
          <b-col md="2" sm="2" cols="4">
            <div @click="send_msg()" class="send_message">
              <div class="text">
                <v-icon v-if="!loading" name="paper-plane"></v-icon
                ><b-spinner v-if="loading" class="align-middle"></b-spinner>
              </div>
            </div>
          </b-col>
        </b-row>
        <hr />

        <b-row> </b-row>
      </div>
    </div>
    <div class="message_template">
      <li class="message left appeared">
        <div class="avatar">Hola</div>
        <div class="text_wrapper">
          Hola
          <div class="text">Holaa</div>
        </div>
      </li>
    </div>
  </div>
</template>
<script>
let socket;
/* eslint-disable */
import Cookies from "js-cookie";
import { mapState, mapActions } from "vuex";
import Swal from "sweetalert2";
import axios from "axios";
import * as Config from "../../config";

export default {
  //props: ["messages", "room"],
  name: "UserChat",
  components: {},
  data() {
    return {
      loading: false,
      id_admin: Cookies.get("id"),
      modalShow: false,
      evaluations: [],
      classes: [],
      tasks: [],
      subject_detail: {
        subject: {
          id: "",
          name: "",
          description: "",
        },
      },
      progress: false,
      fileToUpload: "",
      file_name: "",
      file_description: "",
      file: {
        name: "",
        description: "",
        url: "",
        format: "",
      },
      rooms: [],
      messages: [],
      currentUserId: 1234,
      message_post: "",
      clipboards: [],
      id_room_channel: "",
      id_room_group: "",
      preview_image: "",
    };
  },
  computed: {
    ...mapState({
      //evaluation: (state) => state.evaluation.evaluation,
      me: (state) => state.me,
      id_room_user: (state) => state.id_room_user,
    }),
  },
  mounted() {
    if (this.id_room_user == null) {
      this.$router.push("/admin/users");
    }
    this.start_ws(this.id_room_user, this.id_admin);
    this.loadState();

    let id_user_detail = this.$route.params.user_id;

    //  this.getClipboard();
    // this.scrollToEnd();
    //var objDiv = document.getElementById("MyDivmssElement");
    //objDiv.scrollTop = objDiv.scrollHeight;
  },
  methods: {
    ...mapActions([
      "new_Message",
      "loadChat_Messages",
      "delete_Chat_Message",
      "store_Clipboard",
      "load_Clipboard",
      "uploadArchiveMessageRoom",
    ]),
    start_ws(room_id, user_id) {
      let url = Config.apiPath
      let end = url.indexOf('/api/1.0')
      let url_final = url.substring(0, end)
      
      let opts = { 
        //extraHeaders: { room: room_id, user: user_id } 
        transports: ['websocket'],
        query: { room: room_id, user: user_id }
      };
      socket = io(url_final, opts);

      socket.on("connect", () => {
        console.log("CONNECTED!");
      });

      //Para escuchar si se recibe un mensaje y lo muestra
      socket.on("messagex", (data) => {
        console.log(data);
        this.message_post = "";
        this.messages.push(data);
        setTimeout(() => {
          console.log("SCROLL");
          this.ScrollButton();
        }, 500);
        
        
        console.log("ready");
        /* document.getElementById('picture').innerHTML = '<img src="'+data.user_profile_photo+'" width=20%>'
          document.getElementById('name').innerHTML = data.user_full_name
          document.getElementById('message').innerHTML = data.message */
      });

      //Para evaluar si me unieron a la sala de chat indicada
      socket.on("join_room", (data) => {
        console.log(data);
      });

      //Para manejar errores
      socket.on("error", (error) => {
        console.log(error);
      });

      //Para manejar una desconexión con el servidor
      socket.on("disconnect", () => {
        console.log("CLOSED!");
      });
    },
    send_msg() {
      if (this.message_post.trim() == "") {
        Swal.fire({
          title: "El mensaje está en blanco",
          text: "Escribe un mensaje para enviar",
          icon: "warning",
        });
      } else {
        const data = {
          room_id: this.id_room_user,
          user_id: this.id_admin,
          type_archive: 0,
          format: null,
          url_archive: null,
          message: this.message_post,
        };

        socket.emit("message", data);
      }
    },
    stop_ws() {
      socket.disconnect(true);
    },

    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage(file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;

      reader.onload = (e) => {
        vm.preview_image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    uploadArchive(type) {
      let data = new FormData();
      //let formData = new FormData(document.getElementById("uploadForm"));

      data.append("document", this.fileToUpload);

      let message = this.file_description;

      let id_user = this.me.id;
      let id_room = this.room;

      data.append("message", message);
      data.append("type", type);
      data.append("id_user", id_user);

      data.append("id_room", id_room);

      Swal.fire({
        title: "Confirmación",
        text: "¿Estás seguro de subir este Archivo?",
        icon: "question",
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Subir",
      }).then((result) => {
        if (result.value) {
          this.progress = true;
          this.uploadArchiveMessageRoom(data)
            .then((response) => {
              if (response.code === 200) {
                (this.progress = false),
                  Swal.fire({
                    title: "Subida de Archivo Completada",
                    icon: "success",
                  }).then((result2) => {
                    this.loadState();
                    //this.scrollToEnd();
                    Swal.fire({
                      title: "Mensaje Insertado",
                      text: "El mensaje ha sido insertado en esta evaluación",
                      icon: "success",
                    });
                    this.preview_image = "";
                    this.$bvModal.hide("modal-upload" + this.room);
                    // this.$router.push({ name: "representative_childrens" });
                  });
              }
            })
            .catch((error) => {
              Swal.fire({
                title: "Ocurrio un error",
                text: "Comprueba tu conexion con internet, e intentalo mas tarde",
                icon: "warning",
              });
              this.progress = false;
              console.log(error);
            });
        }
      });
    },
    /*  scrollToEnd: function () {
      var content = this.$refs.container;
      console.log(content);
      console.log("scrollTop:" + content.scrollTop);
      console.log(content.scrollHeight);
      if (content.scrollHeight > content.scrollTop) {
        content.scrollTop = content.scrollHeight;
      }
    }, */
    ScrollButton() {
      var content = this.$refs.container;
     console.log("scrollTop:" + content.scrollTop);
      console.log(content.scrollHeight);
      if (content.scrollHeight > content.scrollTop) {
        content.scrollTop = content.scrollHeight;
      }
    },
    loadState() {
      this.loading = true;
      let form = {
        room: this.id_room_user,
      };
      console.log("IDROOM ACTUAL:" + this.id_room_user);
      this.loadChat_Messages(form)
        .then((response) => {
          if (response.code === 200) {
            this.loading = false;
            let resp = response.data;
            console.log("RESPONSE");
            console.log(resp);
            resp.reverse();

            this.messages = [];
            for (let i in resp) {
              let msg = resp[i];

              this.messages.push(msg);
            }
            setTimeout(() => {
            console.log("SCROLL");
            this.ScrollButton();
        }, 500);
          }
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });

      //LOAD CLIPBOARD
    },

    deleteMsg(msg_id) {
      Swal.fire({
        title: "¿Está seguro de eliminar este mensaje?",
        text: "",
        icon: "question",
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "gray",
        cancelButtonColor: "#121419",
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          let form = {
            status: 2,
            id: msg_id,
          };
          this.delete_Chat_Message(form)
            .then((response) => {
              if (response.code === 200) {
                Swal.fire({
                  title: "Eliminado correctamente",
                  icon: "success",
                });
                this.loadState();
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },

    send() {
      if (this.message_post == "") {
        Swal.fire({
          title: "El mensaje está en blanco",
          text: "Escribe un mensaje para enviar",
          icon: "warning",
        });
      } else {
        let form = {
          user_id: Cookies.get("id"),
          /*          format: null,
          url_archive: null, */
          room_id: this.room,
          message: this.message_post,
          type_archive: 0,
        };
        this.new_Message(form)
          .then((response) => {
            console.log("RESPONSE");
            console.log(response);
            if (response.code == 200) {
              this.message_post = "";
              this.loadState();
              //this.scrollToEnd();
            }
            if (response.code == 500) {
              Swal.fire({
                title: "Ocurrio un error",
                text: "Intenta de nuevo, completa todos los campos",
                icon: "success",
              }).then((result2) => {
                console.log(result2);
              });
            }
          })
          .catch((error) => {
            console.log(error);
            if (error.response.code == 500) {
              Swal.fire({
                title: "Ocurrio un error",
                text: "Intenta de nuevo, completa todos los campos",
                icon: "error",
              }).then((result2) => {
                console.log(result2);
              });
            }
          });
      }
    },
  },
  updated() {
    /*  var content = this.$refs.container;
      console.log(content.scrollTop)
      content.scrollTop = 1000000;
      console.log(content.scrollTop) */
  },
};
</script>

<style scoped>
.chat_window {
  width: 100%;
  max-width: 800px;

  border-radius: 10px;

  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
}

.top_menu {
  background-color: #fff;
  width: 100%;
  padding: 20px 0 15px;
  box-shadow: 0 1px 30px rgba(0, 0, 0, 0.1);
}
.top_menu .buttons {
  margin: 3px 0 0 20px;
  position: absolute;
}
.top_menu .buttons .button {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 10px;
  position: relative;
}
.top_menu .buttons .button.close {
  background-color: #002d4a;
}
.top_menu .buttons .button.minimize {
  background-color: #d4ffe0;
}
.top_menu .buttons .button.maximize {
  background-color: #a3d063;
}
.top_menu .title {
  text-align: center;
  color: #bcbdc0;
  font-size: 20px;
}

.messages {
  position: relative;
  list-style: none;
  padding: 5px 5px 5px 5px;
  margin: 0;

  height: 600px;
  overflow: scroll;
  overflow-x: hidden;
}
.messages .message {
  clear: both;
  overflow: hidden;
  margin-bottom: 10px;
  transition: all 0.5s linear;
  opacity: 0;
}
.messages .message.left .avatar {
  background-color: #fca18a;
  float: left;
}
.messages .message.left .text_wrapper {
  background-color: #3f68c0;
  color: white;
  width: 50%;
  margin-left: 20px;
  
}
.messages .message.left .text_wrapper::after,
.messages .message.left .text_wrapper::before {
  right: 100%;
  border-right-color: #ffffff;
}
.messages .message.left .text {
  color: #ffffff;
  text-align: left;
}
.messages .message.right .avatar {
  background-color: #3f68c0;
  float: right;
}
.messages .message.right .text_wrapper {
  background-color: #e4e5eb;
width: 50%;
  margin-right: 20px;
  float: right;
}
.messages .message.right .text_wrapper::after,
.messages .message.right .text_wrapper::before {
  left: 100%;
  border-left-color: #ffffff;
}
.messages .message.right .text {
  color: #000000;
  text-align: right;
}
.messages .message.appeared {
  opacity: 1;
}
.messages .message .avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: inline-block;
}
.messages .message .text_wrapper {
  display: inline-block;
  padding: 10px;
  margin: 5px;
  border-radius: 6px;
  width: calc(100% - 85px);
  min-width: 100px;
  position: relative;
}
.messages .message .text_wrapper::after,
.messages .message .text_wrapper:before {
  top: 28px;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.messages .message .text_wrapper::after {
  border-width: 13px;
  margin-top: 0px;
}
.messages .message .text_wrapper::before {
  border-width: 15px;
  margin-top: -2px;
}
.messages .message .text_wrapper .text {
  font-size: 18px;
  font-weight: 300;
}

.bottom_wrapper {
  width: 100%;
  background-color: #fff;
  padding: 20px 20px;
  margin-top: 5px;

  bottom: 0;
}
.bottom_wrapper .message_input_wrapper {
  display: inline-block;
  height: 50px;
  border-radius: 25px;
  border: 1px solid #bcbdc0;

  position: relative;
  padding: 0 20px;
}
.bottom_wrapper .message_input_wrapper .message_input {
  border: none;
  height: 100%;
  box-sizing: border-box;

  position: absolute;
  outline-width: 0;
  color: gray;
}
.bottom_wrapper .send_message {
  width: 70px;
  height: 50px;
  display: inline-block;
  border-radius: 50px;
  background-color: #a3d063;
  border: 2px solid #a3d063;
  color: #fff;
  cursor: pointer;
  transition: all 0.2s linear;
  text-align: center;
  float: right;
}
.bottom_wrapper .send_message:hover {
  color: #a3d063;
  background-color: #fff;
}
.bottom_wrapper .send_message .text {
  font-size: 18px;
  font-weight: 300;
  display: inline-block;
  line-height: 48px;
}

.message_template {
  display: none;
  
}
</style>
